import { oc } from '@orpc/contract';
import { refreshInputSchema, tokensOutputSchema } from '../schemas/auth.schemas.js';
export const refreshTokenContract = oc
    .route({
    method: 'POST',
    path: '/auth/refresh',
    tags: ['Auth'],
    summary: 'Rotate a stored refresh token: the presented token is revoked and a fresh pair is issued',
})
    .input(refreshInputSchema)
    .output(tokensOutputSchema);
//# sourceMappingURL=refresh-token.contract.js.map